import Analytics from './Analytics';
import { LOCATION_CHANGE, LocationChangeAction } from 'react-router-redux';
import { Action, Dispatch, MiddlewareAPI } from 'redux';
import { AppState } from '../redux';

export const analyticsMiddleware =
    ({dispatch, getState}: MiddlewareAPI<AppState>) => (next: Dispatch<AppState>) => (action: Action) => {
        if (isLocationChange(action)) {
            const path = action.payload.pathname;            
            getAnalytics(getState).trackPage(`${path.substring(1)}`, `${getState().errorState.errorStates}`);            
        }
        return next(action);
    };

function isLocationChange(action: Action): action is LocationChangeAction {
    return action.type === LOCATION_CHANGE;
}

let analytics: Analytics;
function getAnalytics(getState: () => AppState) {
    if (!analytics) {
        analytics = new Analytics();
    }
    return analytics;
}



// WEBPACK FOOTER //
// ./src/analytics/AnalyticsMiddleware.ts